// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"ba609c4b","94":"85c9e9a1","154":"50ed6203","220":"edfcb2ac","777":"6a03c4ee","824":"ceb55658","916":"5af7e588","928":"f6ad7578","987":"ba609c4b"}[chunkId] + ".chunk.css";
};